export default function VkIcon({ width = 22, height = 14, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 18 11"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M9.44666 10.8225C3.52082 10.8225 0.140842 6.76 0 0H2.96834C3.06584 4.96166 5.25413 7.06332 6.98745 7.49666V0H9.78255V4.27913C11.4942 4.09497 13.2923 2.145 13.899 0H16.6941C16.2282 2.64334 14.2782 4.59332 12.8916 5.39497C14.2782 6.04497 16.4992 7.74582 17.3442 10.8225H14.2674C13.6066 8.76416 11.9601 7.17166 9.78255 6.95497V10.8225H9.44666Z"
                fill="#EAEAEA"
            />
        </svg>
    );
}
